import * as _ from 'lodash';
import { MODULE_NAME } from '../constants/globals';
import LOCALES from '../constants/locales';

const fallbackMessages = require('./usersettings_en-GB.json');

export const SUPPORTED_LOCALES = LOCALES;

export const FALLBACK_LOCALE = 'en-GB';

export function getDefaultLocale() {
    const navLang = navigator.language;
    return SUPPORTED_LOCALES.includes(navLang) ? navLang :
        (SUPPORTED_LOCALES.find(locale => locale.substring(0, 2) === navLang) || FALLBACK_LOCALE);
}

export function prefixMessages(messages) {
    const messagesWithPrefix = {};
    _.forIn(messages, (value, key) => {
        messagesWithPrefix[`${MODULE_NAME}.${key}`] = value;
    });
    return messagesWithPrefix;
}

const languageDataObjects = {
    [FALLBACK_LOCALE]: {
        locale: FALLBACK_LOCALE,
        localeShort: FALLBACK_LOCALE.substring(0, 2),
        messagesByLanguage: prefixMessages(fallbackMessages),
    },
};

export function addLanguageObject(locale, messages) {
    languageDataObjects[locale] = {
        locale: locale,
        localeShort: locale.substring(0, 2),
        messagesByLanguage: prefixMessages(messages),
    };
}

export function getLanguageData(locale) {
    return languageDataObjects[locale] || languageDataObjects[getDefaultLocale()] ||
        languageDataObjects[FALLBACK_LOCALE];
}

export function translate(id, locale) {
    const languageData = getLanguageData(locale);
    return languageData.messagesByLanguage[id];
}
